import { createTopic, ConfigActions } from '../lib';
import { z } from 'zod';

const entityDocRenderedEventSchema = z.object({
  entityRef: z
    .string()
    .describe('The reference name for this system or component.'),
});

export type EntityDocRenderedEvent = z.infer<
  typeof entityDocRenderedEventSchema
>;

export const entityDocRenderedTopic = createTopic<EntityDocRenderedEvent>(
  {
    namespace: 'catalog',
    name: 'entity-doc-rendered',
    description: 'Docs for a system/component have been rendered',
  },
  entityDocRenderedEventSchema,
  s => [{ action: ConfigActions.HASH, path: s.entityRef }],
);
